import { AddressAutocompleteField, Button, Input } from '@goodneighbor/ui';
import { MarkerPin02, SearchLg } from '@goodneighbor/ui/icons/untitled';
import styles from './eventSearchBar.module.scss';

export type EventSearchBarProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  locationValue: string;
  onLocationChange: (value: string) => void;
  onLocationSelect: (
    place: google.maps.GeocoderResult | google.maps.places.PlaceResult
  ) => void;
  onLocationBlur: () => void;
  locationError?: string | null;
  onSubmit: () => void;
};

export default function EventSearchBar({
  searchValue,
  onSearchChange,
  locationValue,
  onLocationChange,
  onLocationSelect,
  onLocationBlur,
  locationError,
  onSubmit
}: EventSearchBarProps) {
  return (
    <div className={styles.searchBar}>
      <div className={styles.inputWrapper}>
        <Input
          placeholder="Search organization or events..."
          value={searchValue}
          onChange={onSearchChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSubmit();
            }
          }}
          wrapperClassName={styles.inputField}
          inputClassName={styles.inputFieldInput}
        />
      </div>
      <div className={styles.searchDivider} aria-hidden />
      <div className={styles.inputWrapper}>
        <AddressAutocompleteField
          placeholder="Choose city..."
          value={locationValue}
          onChange={onLocationChange}
          onBlur={onLocationBlur}
          onPlaceSelected={onLocationSelect}
          wrapperClassName={styles.inputField}
          inputClassName={styles.inputFieldInput}
          icon={MarkerPin02}
          searchOptions={{ types: ['(cities)'] }}
          isInvalid={Boolean(locationError)}
          hint={locationError || undefined}
          aria-label="Choose a city"
        />
      </div>
      <Button
        color="primary"
        size="md"
        aria-label="Search"
        iconLeading={<SearchLg color="var(--color-fg-white)" />}
        className={styles.searchIconButton}
        onClick={onSubmit}
      />
    </div>
  );
}
